import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-number-picker',
  standalone: false,
  templateUrl: './custom-number-picker.component.html',
  styleUrl: './custom-number-picker.component.scss'
})
export class CustomNumberPickerComponent {
  constructor() { }

  @Input() text: string;
  @Input() model: number;

  @Input() useIcon: boolean = false;
  @Input() classIcon: string = "fas fa-user";
  @Input() iconCount: number = 1;

  @Output() changeModel = new EventEmitter<number>();


  /**
  * @description if true, this component increase model passed
  */
  @Input() modifyModel: boolean = true;

  /**
  * @description default 0
  */
  @Input() min: number = 0;
  /**
  * @description default 10
  */
  @Input() max: number = 10;

  @Output() decrease = new EventEmitter();
  @Output() increase = new EventEmitter();

  emitIncrease() {
    if (this.modifyModel) {
      this.model++;
      this.changeModel.emit(this.model);
    }
    this.increase.emit();
  }

  emitDecrease() {
    if (this.modifyModel) {
      this.model--;
      this.changeModel.emit(this.model);
    }
    this.decrease.emit();
  }
}
